var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-liveview__map",class:{
    'close-history': _vm.$store.state.map.modalFleetHistory === true,
    '':
      _vm.$store.state.map.modalFleetHistory === false,
  }},[_c('RightButton'),(_vm.$store.state.map.type === 'fleet')?_c('GmapFleet',{attrs:{"temporary-live-view":_vm.temporaryLiveView}}):(_vm.$store.state.map.type === 'history')?_c('GmapHistory'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }